export const HIGHLIGHTED_DELAY = 10000;
